import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { HashRouter as Router } from 'react-router-dom';
import Login from './pages/Login/Login';
import Register from './pages/Register/Register';
import Recover from './pages/Recover/Recover';

import './Sso.scss';

function Sso() {
  return (
    <div>
      <Switch>
        <Route path="/login">
          <Login />
        </Route>
        <Route path="/register">
          <Register />
        </Route>
        <Route path="/recover">
          <Recover />
        </Route>
        <Route>
          <Redirect to="/login" />
        </Route>
      </Switch>
    </div>
  );
}

const SsoWrapper = () => (
  <Router basename="/sso">
    <Sso />
  </Router>
);

export default SsoWrapper;
